// extracted by mini-css-extract-plugin
module.exports = {"modalSection":"Section_modalSection__GibiM"};